export const ALL = "All";
export const NONE = "None";

export const SWAP_DIRECTION = {
  UP: "up",
  DOWN: "down",
};
